module.exports = __webpack_public_path__ + "img/pic-logo-CourseCentre.ef199188.png";